import React, {PropTypes} from 'react';
import {__} from '../../../server/lib/i18n-2/browserHelper'

const CompanyContainer = (props) => (
  <div className="project-snippet-component">
    {props.children}
    {props.showFinishedResults &&
      <div className="after empty">
        {__('Žádné další výsledky')}
      </div>
    }
    {props.showAllButton &&
      <div className="after more btn-classic btn-white btn-wide" onClick={(e) => props.handleAllButtonClick(e)}>
        {__('Načíst všechny firmy na prodej')}
      </div>
    }
  </div>
)

export default CompanyContainer



// WEBPACK FOOTER //
// ./src/browser/components/stateless/CompanyContainer.react.js